import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import urls from 'config/urls.json';
import { toast } from 'react-toastify';
import { get } from 'utils/axios';

export const getCharacters = createAsyncThunk('GET_CHARACTERS', async (data, thunkAPI) => {
  const response = await get(`${urls.GET_CHARACTERS}`, data, thunkAPI);
  return response.data;
});

export const getCharacterDetails = createAsyncThunk('GET_CHARACTER_DETAILS', async (data, thunkAPI) => {
  const response = await get(`${urls.GET_CHARACTER_DETAILS}/${data}`, {}, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  characters: [],
  loadingCharacterDetails: false,
  selectedCharacterDetails: null
};

export const characterSlice = createSlice({
  name: 'character',
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCharacters.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCharacters.fulfilled, (state, action) => {
        const { success, characters } = action.payload;
        if (success) {
          state.characters = characters;
        } else {
          toast.error('Something went wrong!', 3000);
        }
        state.isLoading = false;
      })
      .addCase(getCharacters.rejected, (state, action) => {
        toast.error(action.payload?.message || 'Something went wrong', 3000);
        state.isLoading = false;
      });

    builder
      .addCase(getCharacterDetails.pending, (state) => {
        state.selectedCharacterDetails = null;
        state.loadingCharacterDetails = true;
      })
      .addCase(getCharacterDetails.fulfilled, (state, action) => {
        const { character } = action.payload;
        state.selectedCharacterDetails = character;
        state.loadingCharacterDetails = false;
      })
      .addCase(getCharacterDetails.rejected, (state, action) => {
        toast.error(action.payload?.message || 'Something went wrong', 3000);
        state.loadingCharacterDetails = false;
      });
  }
});

export const { reset } = characterSlice.actions;

export default characterSlice.reducer;
